import React, { useState } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import { Card } from "@mui/material";
import { endpoints } from "../../../../services/apiurl";
import Input from "../../../UI/Input/Input";
import PageTitle from "../../../UI/PageTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const AddSubCategory = () => {
  let history = useHistory();
  let { cat_id } = useParams();
  var restro_id = localStorage.getItem("restro_id");
  var section_id = localStorage.getItem("section_id");

  const [cat, setCat] = useState({
    name: "",
    status: "",
  });
  const { name, status } = cat;
  const [loading, setloading] = useState(false);

  const onInputChange = (e) => {
    setCat({ ...cat, [e.target.name]: e.target.value });
    // console.log(cat);
  };

  const onSubmit = async (e) => {
    setloading(true);
    e.preventDefault();
    const formData = new FormData();
    formData.append("name", name);
    formData.append("status", status);
    formData.append("cat_id", cat_id);
    formData.append("restro_id", restro_id);
    formData.append("section_id", section_id);
    try {
      const response = await axios.post(endpoints.addSubCategory, formData);
      setloading(false);
      history.goBack();
      if (response.data && response.data.status === true) {
        toast.success("SubCategory Added Successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        // Handle other cases if needed
      }
    } catch (error) {
      console.error("Error during editing SubCategory:", error);
      setloading(false);

      toast.error("Error during editing SubCategory. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  return (
    <div className="ui main">
      <PageTitle title="Add Sub Category" linkurl="" linkTitle="" />

      <Card className="px-3 py-3">
        <form
          className="ui form"
          onSubmit={(e) => onSubmit(e)}
          encType="multipart/form-data"
        >
          <div className="row">
            <Input
              id="name"
              label="Name"
              type="text"
              name="name"
              place="Name"
              onChange={(e) => onInputChange(e)}
              requiredInput="required"
              value={name}
              class="col col-6"
            />
            <div className="col col-6">
              <label>Status</label>
              <select
                name="status"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select Status</option>
                <option value="2">InActive</option>
                <option value="1">Active</option>
              </select>
            </div>
          </div>

          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                <LoadingButton
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                >
                  Save
                </LoadingButton>
                <ToastContainer />
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default AddSubCategory;
